import {ToastService} from "../../../../core/services/toast.service";
import {HttpClientService} from "../../../../core/services/http-client.service";
import {CommonService} from "../../../../core/services/common.service";
import {ActivatedRoute, Router} from "@angular/router";
import {combineLatest as observableCombineLatest,  Observable } from 'rxjs';
import {Component} from "@angular/core";

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent {
  user: any = {};

  customer: any = {};
  public loading: boolean = false;
  constructor(private toast: ToastService,
    private httpService: HttpClientService,
    private common: CommonService,
    private route: ActivatedRoute,
    private _router: Router) {
  }
  ngOnInit() {

    observableCombineLatest([
      this.route.data,
      this.route.queryParams,
      this.route.params,
    ]).subscribe((bothParams) => {
      this.user.mobile = +bothParams[1].mobile;
    });
  }

  back() {
    window.history.back();
  }
  public registeruser(params): Observable<any> {
    return this.httpService.post(`store/register`, params);
  };
  register() {
    this.loading = true;
    this.registeruser(this.user).subscribe(response => {
      this.loading = false;

      this.customer = response.response;
      this.common.setStorage('customer', this.customer);
      this.common.setLoggedIn(true);
      this.toast.info('Registeration successful');
      this._router.navigate([this.common.getNavigteUrl()]);
    });
  }
}
